enum CrossSellProductCTAStatusEnum {
  AddToBasket = 'AddToBasket',
  Added = 'Added',
  Remove = 'Remove',
}

export default CrossSellProductCTAStatusEnum;
